export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10340.3291746e.jpg";